import type { AuthSettings } from "@entrilia/shared/auth/authTypes";
import { importEnvVariable } from "@entrilia/shared/variables";

interface EnvVariables {
  LOGIN_APP_URI: string;
  IR_PORTAL_URI: string;
  DEVELOPER_TOOLS: string;
}

let variables: EnvVariables | undefined = undefined;

const importVariables = () => ({
  LOGIN_APP_URI: importEnvVariable("REACT_APP_LOGIN_APP_URI"),
  IR_PORTAL_URI: importEnvVariable("REACT_APP_IR_PORTAL_URI"),
  DEVELOPER_TOOLS: importEnvVariable("REACT_APP_DEVELOPER_TOOLS"),
});

export const getVariables = (): EnvVariables => {
  if (variables === undefined) {
    variables = importVariables();
  }
  return variables;
};

export const importAuthSettings = (): AuthSettings => ({
  authEndpoint: importEnvVariable("REACT_APP_ADMIN_PORTAL_AUTH_ENDPOINT"),
  userFlowSignIn: "",
  userFlowSignUp: "",
  userFlowPasswordReset: "",
  clientId: importEnvVariable("REACT_APP_ADMIN_PORTAL_CLIENT_ID"),
  portalAccessScope: importEnvVariable("REACT_APP_ADMIN_PORTAL_ACCESS_SCOPE"),
  authCookieNames: "x-entrilia-ap-authorized",
  refreshCookieNames: "x-entrilia-ap-refresh-available",
  cookieTarget: "ap",
});
